export function qs(selector, parent = document) {
    return parent.querySelector(selector);
}

export function qsa(selector, parent = document) {
    return Array.from(parent.querySelectorAll(selector));
}

export function on(element, eventName, handler, options) {
    if (!element) return;
    element.addEventListener(eventName, handler, options);
}

export function hasDataPage(pageName) {
    return document.body.dataset.page === pageName;
}